module.exports = "https://static.wmbcdn.com/uniweb/images/e8f8c1acca61b5934ddbacb25b9b38d9.svg";